import { useCallback, useState } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_GET_RECOVERY_CODES } from '@/app/module/user/definitions'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetRecoveryCodes = () => {
  const dispatch = useAppDispatch()
  const [hideCodes, setHideCodes] = useState(true)
  const [trigger, res] = esApi.useLazyGetUserRecoveryCodesQuery()

  const getCodes = useCallback(async () => {
    if (!hideCodes) {
      setHideCodes(true)
      return
    }
    try {
      await trigger(undefined, true).unwrap()
      setHideCodes(false)
    } catch (error) {
      dispatch(
        createNotification({
          'get-recovery-codes': {
            type: 'error',
            message: getErrorMessage(error, ERROR_GET_RECOVERY_CODES),
          },
        }),
      )
    }
  }, [hideCodes, dispatch, trigger])

  return { hideCodes, res, getCodes }
}
